import React from 'react';
// import clsx from 'clsx';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Field, reduxForm, getFormValues} from 'redux-form';

import {withStyles} from '@mui/styles';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import SearchIcon from '@mui/icons-material/Search';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
// import PublishIcon from '@mui/icons-material/Publish';
// import EditIcon from '@mui/icons-material/Edit';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import GetAppIcon from '@mui/icons-material/GetApp';
// import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
// import InfoOutlined from '@mui/icons-material/InfoOutlined';
// import Printicon from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
import {
// Box,
// Tab,
} from '@mui/material';
import {
// TabContext,
// TabList,
// TabPanel,
} from '@mui/lab';

import {
  FlexGridColumnGroup,
  // FlexGridCellTemplate
} from '@grapecity/wijmo.react.grid';

import {
// createTyohyoPdf,
// getCodeFromGeneralPurposeMap,
// changeDateFormat,
// getErrorCode,
// API_CODE,
// getErrorMessages,
// getResponseResult,
// getDataFromGeneralPurposeMap,
// getMaxDeleteNum
} from '../../../../common/common.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {commonOperations} from '../../../../reducks/common';
import {attachorderOperations} from '../../../../reducks/attachorder';
import MainContainer from '../../../organisms/MainContainer.js';
import {renderTextField, renderSelect, renderSelectMultiLine} from '../../../atoms/CustomPart.js';
// import {createSearchList} from '../../../../../common/ComboParts.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
// import MuiTooltip from '../../../../atoms/MuiTooltip.js';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import DangerButton from '../../..//atoms/Buttons/DangerButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
import NegativeButton from '../../../atoms/Buttons/NegativeButton.js';
// import KyogaCompanyInfo from '../../../../molecules/KyogaCompanyInformation.js';
// import * as validateRule from '../../../validateRule.js';
import PaperPart from '../../../atoms/PaperPart.js';
import withRouter from '../../../organisms/withRouter.js';
import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';
import {setSessionObject} from '../../../../common/Session.js';
import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
// import SaveIcon from '@mui/icons-material/Save';
// import {
//   FormControl,
//   FormGroup,
// } from '@mui/material';
import ApprovalStatus from '../../../organisms/Approval/ApprovalStatus/index.js';
import ApprovalComment from '../../../organisms/Approval/ApprovalComment/index.js';
import {CellType} from '@grapecity/wijmo.grid';
// import {removeClass} from '@grapecity/wijmo';
// import {addClass} from '@grapecity/wijmo';

import CheckCircle from '@mui/icons-material/CheckCircle';
import Cancel from '@mui/icons-material/Cancel';
import CustomAccordion from '../../../molecules/Accordion.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// パンくずパラメータ
const transitionList = [
  {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
  {gmnName: GMN.TSTK_RESULT_CONFIRM_LIST.name, href: ''},
];

const styles = (theme) => ({

});

// 一覧
const kenViews = [
  {binding: 'nwJigyosyo', header: 'NW事業所', dataType: 'String', width: 120, readOnly: true},
  {binding: 'tyousakikan', header: '調査機関', dataType: 'String', width: 120, readOnly: true},
  // {binding: 'tskkJgyosyo', header: '調査機関事業所', dataType: 'String', width: 100, readOnly: true},

  {binding: 'reportDate', header: '報告年月日', dataType: 'CellMaker', width: 120, readOnly: true},
  {header: '調査（件）', dataType: 'header', elems: [
    // {binding: 'tsStatus40', header: '完了', dataType: 'Number', width: 95, readOnly: true},
    // {binding: 'tsStatus50', header: '工組承認待ち', dataType: 'Number', width: 95, readOnly: true},
    {binding: 'tsStatus60', header: '承認中', dataType: 'Number', width: 95, readOnly: true},
    {binding: 'tsStatus90', header: '完了', dataType: 'Number', width: 95, readOnly: true},
  ]},
  {header: '再調査（件）', dataType: 'header', elems: [
    // {binding: 'tsStatus40', header: '完了', dataType: 'Number', width: 95, readOnly: true},
    // {binding: 'tsStatus50', header: '工組承認待ち', dataType: 'Number', width: 95, readOnly: true},
    {binding: 'tsStatus60Re', header: '承認中', dataType: 'Number', width: 95, readOnly: true},
    {binding: 'tsStatus90Re', header: '完了', dataType: 'Number', width: 95, readOnly: true},
  ]},
  // {binding: 'tsStatus90', header: '調査（件）', dataType: 'Number', width: 95, readOnly: true},
  // {binding: 'tsReTs', header: '再調査（件）', dataType: 'Number', width: 90, readOnly: true},
  {header: '点検（件）', dataType: 'header', elems: [
    // {binding: 'tkStatusReport', header: '報告', dataType: 'Number', width: 95, readOnly: true},
    {binding: 'tkStatus50', header: '確認中', dataType: 'Number', width: 95, readOnly: true},
    {binding: 'tkStatus60', header: '承認中', dataType: 'Number', width: 95, readOnly: true},
    // {binding: 'tkStatus70', header: 'NWC承認待ち', dataType: 'Number', width: 95, readOnly: true},
    {binding: 'tkStatus90', header: '完了', dataType: 'Number', width: 95, readOnly: true},
    {binding: 'tkFuryo', header: '不良等有', dataType: 'Number', width: 95, readOnly: true},
  ]},

];
const exceptFiltersBindings = [
  'tsStatus60', 'tsStatus90', 'tsStatus60Re', 'tsStatus90Re',
  'tkStatusReport', 'tkStatus50', 'tkStatus60', 'tkStatus90', 'tkFuryo',
];

/**
 * 調査・点検結果確認画面
 * 画面ID:SCE1001
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonDisabled: true,
      buttonDisabled2: true,
      warningMessages: [],
    };

    this.gridRef = React.createRef();
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.props.doSetReferenceMode(false);
      // FlexGridに初期値設定
      if (this.gridRef && this.gridRef.current) {
        // this.gridRef.current.setInitItems('1001', []);
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  }

  /**
     * 終了処理
     */
  async componentWillUnmount() {
    this.props.reset();
    this.props.doClearOrderList();
    this.props.doClearOrder();
    // if (this.gridRef && this.gridRef.current) {
    //   this.gridRef.current.saveScreenState('1001', 'Id');
    //   this.gridRef.current.setItems(null);
    // }
  }

  /**
   * 検索処理
   */
  _searchOrder = async () => {
    const dataKen =[
      {tyousakikan: '中電ＮＷ', tskkJgyosyo: '', nwJigyosyo: '広島NWC', reportDate: '2026/8/9', tsStatus60: '30', tsStatus90: '28', tsStatus60Re: '3', tsStatus90Re: '2', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '1'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/10', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/11', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/12', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/13', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/14', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '1'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/15', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/16', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/17', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '1'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/18', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/19', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '1'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/20', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/21', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/22', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/23', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/24', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '0'},
      {tyousakikan: '工業組合', tskkJgyosyo: '広島支', nwJigyosyo: '広島NWC', reportDate: '2026/8/25', tkStatusReport: '120', tkStatus50: '80', tkStatus60: '30', tkStatus90: '10', tkFuryo: '10', tkSm50: '1'},


    ];

    this.gridRef.current.setItemsSource(dataKen);
    return true;
  };

  /**
   * クリア処理
   */
  _reset = async () => {
    this.setState({buttonDisabled2: true, warningMessages: []});
    const values = this.props.values;
    console.log(values);
    await this.props.reset();
    const data =[];
    this.gridRef.current.setItemsSource(data);
    return true;
  };

  /**
   * 検索ボタン押下時処理
   * @param {bool} show
   */
  doSearch = async () => {
    this.setState({buttonDisabled2: false});
    this._searchOrder();
  };

  /**
  * ボタンの活性、非活性化
  */
  checkStateUpdate = () => {
    try {
      let bRet = false;

      if (this.gridRef && this.gridRef.current &&
        this.gridRef.current.selectedItemCount() > 0) {
        bRet = true;
      }

      if (bRet) {
        this.setState({buttonDisabled: false});
      } else {
        this.setState({buttonDisabled: true});
      }
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 承認状況画面の表示
   */
  displayApproval = () => {
    this.setState({
      showApprovalModal: true,
    });
  };

  /**
 * 承認状況画面を閉じる
 */
  closeApproval = () => {
    this.setState({
      showApprovalModal: false,
    });
  };

  /**
   * 承認画面の表示
   *  @param {object} tstkFlag イベント
   * @param {object} approvalType 選択したデータ
   */
  displayApprovalComment = (tstkFlag, approvalType) => {
    this.setState({
      showApprovalCommentModal: true,
      tstkFlag: tstkFlag,
      approvalType: approvalType,
    });
  };
  /**
 * 否認画面を閉じる
 */
  closeApprovalComment = () => {
    this.setState({
      showApprovalCommentModal: false,
    });
  };

  doSyoninShinsei = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['報告'],
      },
    });
  };

  doApprove = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['承認'],
      },
    });
  };

  doConfirm = () => {
    this.props.doShowMessage({
      message: {
        id: 'BFY000009I',
        values: ['確認'],
      },
    });
  };


  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    if (view.dataType === 'CellMaker') {
      if (view.binding === 'reportDate') {
        return <FlexGridColumnGroup
          binding={view.binding}
          header={view.header}
          dataType='String'
          width={view.width}
          align={view.align}
          cellTemplate= {CellMaker.makeLink({
          // cssClass: 'bf-btn-navy',
            click: (e, ctx) => {
              this.doEditLink(ctx.item.reportDate, ctx.item.reportDate);
            },
            attributes: {
              tabindex: -1,
            },
          })}/>;
      } else if (view.binding === 'sinnseiStatus') {
        return <FlexGridColumnGroup
          binding={view.binding}
          header={view.header}
          dataType='String'
          width={view.width}
          align={view.align}
          cellTemplate= {CellMaker.makeLink({
          // cssClass: 'bf-btn-navy',
            click: (e, ctx) => {
              this.displayApproval();
            },
            attributes: {
              tabindex: -1,
            },
          })}/>;
      }
    }

    if (view.binding === 'blockNo') {
      return <FlexGridColumnGroup
        binding={view.binding}
        header={view.header}
        dataType='String'
        width={view.width}
        align={view.align}
        cellTemplate= {CellMaker.makeLink({
        // cssClass: 'bf-btn-navy',
          click: (e, ctx) => {
            this.doEditLink(ctx.item.blockNo, ctx.item.blockNo);
          },
          attributes: {
            tabindex: -1,
          },
        })}/>;
    }

    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}
      align={view.align}
      cssClass={view.cssClass}/>;
  };

  /**
   * 項目フォーマット処理
   *
   * @param {object} s sender
   * @param {string} e event
   */
  formatItemFunction = (s, e) => {
    // 行が存在しない場合は終了
    const rows = s.rows;
    if (rows.length == 0) {
      return;
    }

    if (e.panel.cellType == CellType.Cell) {
      // e.cell.sytle.cssClass ='';
      // e.cell.sytle.cssClass ='oken-cell-font-red';
      const col = e.getColumn();
      const data = s.rows[e.row].dataItem;

      // 差戻がある場合、文字色は赤に設定する。
      if (col.binding === 'tkStatus50' && data.tkSm50 === '1') {
        e.cell.innerHTML = '<div style="color:red">'+data.tkStatus50+'</div>';
      }
    }
  };

  /**
   * 県一覧表示
   * @return {object}
   */
  renderTable() {
    const props = {
      rowHeaderType: 'check',
      filterOn: true,
      exceptFilters: exceptFiltersBindings,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxHeight: 'auto', maxWidth: 'auto', height: 'auto', width: 'auto'},
      // isReadOnly: true,
      checkedFunction: this.checkStateUpdate,
      formatItemFunction: this.formatItemFunction,
    };

    let viewElems = [];
    if (kenViews) {
      for (const view of kenViews) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          for (const elem of view.elems) {
            if (elem.dataType === 'Select') {
              viewGroups.push(this.getViewElemComboBox(elem, false));
            } else {
              viewGroups.push(this.getViewElem(elem));
            }
          }
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else if (view.dataType === 'Select') {
          viewElem = this.getViewElemComboBox(view, false);
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }

    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }
  /**
   * 一覧リンククリック時
   * @param {*} tskkJgyosyo 調査機関事業所
   * @param {*} sinnseiStatus ステータス
   */
  doEditLink = async (tskkJgyosyo, sinnseiStatus) => {
    try {
      let params = {
        tskkJgyosyo,
        mod: 'C',
      };

      // 調査・点検箇所一覧画面に遷移
      setSessionObject(GMN.TSTK_KASYO_LIST.id, params);
      this.props.navigate(GMN_PATH.TSTK_KASYO_LIST);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 検索条件タブの要素生成
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  renderCondition() {
    return (
      <React.Fragment>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          <Grid key="surveyYear" item xs={12} sm={1}>
            <Field
              id="surveyYear"
              name="surveyYear"
              component={renderSelect}
              className="fields"
              label="年度"
              fullWidth
              type="text"
              required={true}
              validate={[

              ]}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'2026'}</MenuItem>
              <MenuItem value={2}>{'2025'}</MenuItem>
              <MenuItem value={3}>{'2024'}</MenuItem>
            </Field>
          </Grid>
          <Grid key="zigyoujo" item xs={12} sm={2}>
            <Field
              id="zigyoujo"
              name="zigyoujo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="NW事業所"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={5100}>{'広島NWC'}</MenuItem>
              <MenuItem value={5110}>{'福山NWC'}</MenuItem>
              <MenuItem value={5120}>{'尾道NWC'}</MenuItem>
              <MenuItem value={5130}>{'三次NWC'}</MenuItem>
              <MenuItem value={5140}>{'呉NWC'}</MenuItem>
              <MenuItem value={5160}>{'広島北NWC'}</MenuItem>
              <MenuItem value={5170}>{'廿日市NWC'}</MenuItem>
              <MenuItem value={5190}>{'東広島NWC'}</MenuItem>
              <MenuItem value={5250}>{'矢野NWC '}</MenuItem>
            </Field>
          </Grid>
          <Grid key="tyousakikan" item xs={12} sm={2}>
            <Field
              id="tyousakikan"
              name="tyousakikan"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査会社"
              fullWidth
              required={true}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={'0000'}>{'中電ＮＷ'}</MenuItem>
              <MenuItem value={3000}>{'保安協会'}</MenuItem>
              <MenuItem value={5000}>{'工業組合'}</MenuItem>
            </Field>
          </Grid>
          {/* <Grid key="tskkJgyosyo" item xs={12} sm={2}>
            <Field
              id="tskkJgyosyo"
              name="tskkJgyosyo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査機関事業所"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={4510}>{'福山支'}</MenuItem>
              <MenuItem value={4580}>{'府中支'}</MenuItem>

            </Field>
          </Grid> */}
          <Grid key="reportDate" item xs={12} sm={4}>
            <div style={{position: 'relative'}}>
              <Field
                id="reportDateFrom"
                name="reportDateFrom"
                // accessibilitylabel={option.id + 'From'}
                label="報告年月日"
                component={renderTextField}
                className="fields"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                // validate={[
                //   validateRule.date,
                //   validateRule.correctFromDate(values ? values[option.id + 'To'] : null),
                // ]}
              />
              <span className="wave">～</span>
              <Field
                id="reportDateTo"
                name="reportDateTo"
                // accessibilitylabel={option.id + 'To'}
                label={<React.Fragment />}
                component={renderTextField}
                className="fields"
                type="date"
                InputLabelProps={{
                  shrink: true,
                }}
                // validate={[
                //   validateRule.date,
                //   validateRule.correctDate(values ? values[option.id + 'From'] : null),
                // ]}
              />
            </div>
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
          direction={'row'}
        >
          {/* <Grid key="tenKenFuryo" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="tenKenFuryo"
                  name="tenKenFuryo"
                  component={renderCheckbox}
                  label="点検不良あり"
                  onChange={this._handleChangeCheckbox}
                  // isChecked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid key="hiKetu" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="hiKetu"
                  name="hiKetu"
                  component={renderCheckbox}
                  label="否決あり"
                  onChange={this._handleChangeCheckbox}
                  // isChecked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid> */}
          <Grid key="tenKenFuryo" item xs={12} sm={2}>
            <Field
              id="tenKenFuryo"
              name="tenKenFuryo"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="点検不良"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'不良あり'}</MenuItem>
              <MenuItem value={2}>{'不良なし'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="tyousaRyouCd" item xs={12} sm={2}>
            <Field
              id="tyousaRyouCd"
              name="tyousaRyouCd"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="調査良否区分"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'良'}</MenuItem>
              <MenuItem value={2}>{'不良'}</MenuItem>
              <MenuItem value={3}>{'不能'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="smdsZtiKbn" item xs={12} sm={2}>
            <Field
              id="smdsZtiKbn"
              name="smdsZtiKbn"
              // variant="standard"
              component={renderSelect}
              className="fields"
              label="否決"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={1}>{'否決あり'}</MenuItem>
              <MenuItem value={2}>{'否決なし'}</MenuItem>

            </Field>
          </Grid>
          <Grid key="tsStatus" item xs={12} sm={3}>
            <Field
              id="tsStatus"
              name="tsStatus"
              // variant="standard"
              component={renderSelectMultiLine}
              className="fields"
              label="調査・点検ステータス"
              type="text"
              fullWidth
              required={false}
              validate={[
              ]}
              InputProps={{
                readOnly: false,
              }}
            >
              <MenuItem value="">&nbsp;</MenuItem>
              <MenuItem value={10}>{'未着手'}</MenuItem>
              <MenuItem value={20}>{'調査中／点検中'}</MenuItem>
              <MenuItem value={30}>{'調査済／点検済'}</MenuItem>
              <MenuItem value={40}>{'報告中'}</MenuItem>
              <MenuItem value={50}>{'確認中'}</MenuItem>
              <MenuItem value={60}>{'承認中'}</MenuItem>
              <MenuItem value={90}>{'完了'}</MenuItem>
            </Field>
          </Grid>
          {/* <Grid key="hiKetu" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="hiKetu"
                  name="hiKetu"
                  component={renderCheckbox}
                  label="確認待ち"
                  onChange={this._handleChangeCheckbox}
                  checked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid key="hiKetu" item xs={12} sm={2}>
            <FormControl component="fieldset" className="formControl">
              <FormGroup row={true}>
                <Field className="checkbox"
                  id="hiKetu"
                  name="hiKetu"
                  component={renderCheckbox}
                  label="承認待ち"
                  onChange={this._handleChangeCheckbox}
                  checked="true"
                  validate={[]}
                  sx={{marginLeft: '20px'}}
                />
              </FormGroup>
            </FormControl>
          </Grid> */}
        </Grid>
      </React.Fragment>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    // const {
    //   handleSubmit,
    // } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        {/* <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={this.doConfirm}
            variant="contained"
            startIcon={<CheckCircle />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>確認</span>
          </PositiveButton>
        </Grid> */}
        <Grid key="key1001CreateTen3" item>
          <PositiveButton
            id="btn1001CreateTen3"
            onClick={()=>{
              this.displayApprovalComment(false, '1');
            }}
            variant="contained"
            startIcon={<CheckCircle />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>承認</span>
          </PositiveButton>
        </Grid>
        <Grid key="key1001CreateTen4" item>
          <DangerButton
            id="btn1001CreateTen4"
            onClick={()=>{
              this.displayApprovalComment(true, '2');
            }}
            variant="contained"
            startIcon={<Cancel />}
            // onClick={this.doDelete}
            // size="large"
          >
            <span>否決</span>
          </DangerButton>
        </Grid>
      </Grid>
    );
  };

  render() {
    const {classes,
      // generalPurposeMap,
      // reset,
      handleSubmit,
      // values,
      //  userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    // const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          footerBtn={footerBtn}>
          <CustomBreadcrumbs key="keyBreadcrumbs" items={transitionList}/>
          <Grid key="keySCA1001Msg" item xs={12}>
            <WarningMessageArea messages={this.state.warningMessages}/>
          </Grid>
          <PaperPart>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="flex-start"
              spacing={1}
            >
              <Grid key="search" item xs={12}>
                <CustomAccordion title='検索条件' items={[this.renderCondition()]} defaultExpanded={true}/>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="right"
              alignItems="right"
            >
              <Grid key="clear" item>
                <NegativeButton
                  id="clear"
                  variant="contained"
                  startIcon={<RotateLeftIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this._reset)}
                >
                  <span>クリア</span>
                </NegativeButton>
              </Grid>
              <Grid key="search" item>
                <PositiveButton
                  id="search"
                  variant="contained"
                  startIcon={<SearchIcon />}
                  className="button_list"
                  size="middle"
                  onClick={handleSubmit(this.doSearch)}
                >
                  <span>検索</span>
                </PositiveButton>
              </Grid>
            </Grid>
          </PaperPart>
          <div style={{marginBottom: '20px'}} />
          <Divider variant="middle" />
          <div style={{marginBottom: '20px'}} />
          <Grid container
            justifyContent="flex-start"
            alignItems="flex-start"
            direction={'row'}
          >
            {this.renderTable()}
          </Grid>
        </MainContainer>
        <ApprovalStatus
          openState={this.state.showApprovalModal}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.displayApprovalModal}
          handleClose = {this.closeApproval}/>
        <ApprovalComment
          openState={this.state.showApprovalCommentModal}
          tstkFlag={this.state.tstkFlag}
          approvalType={this.state.approvalType}
          // handleExec={handleSubmit(this.displaySpecification)}
          // handleExec={this.closeApprovalComment}
          handleClose = {this.closeApprovalComment}/>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object,
  generalPurposeMap: PropTypes.object,
  orderList: PropTypes.array,
  history: PropTypes.object,
  values: PropTypes.object,
  userInfo: PropTypes.object,
  order: PropTypes.object,
  reset: PropTypes.func,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doGetOrderTypeList: PropTypes.func,
  doSetOrderId: PropTypes.func,
  doDeleteProprietyOrder: PropTypes.func,
  doClearOrderInfo: PropTypes.func,
  doSetStbType: PropTypes.func,
  doClearOrderList: PropTypes.func,
  doRetrieveOrder: PropTypes.func,
  doClearOrder: PropTypes.func,
  doSetReferenceMode: PropTypes.func,
  doSetOrderModifiedCondition: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    generalPurposeMap: state.common.generalPurposeMap,
    userInfo: state.auth.userInfo,
    orderList: state.attachorder.orderList,
    order: state.attachorder.order,
    initialValues: {
      surveyYear: '1',
      zigyoujo: '5160',
      tyousakikan: '0000',
      // tyousakikan: '保安協会',
    },
    // initialValues: state.common.setInitValues,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doGetOrderTypeList: attachorderOperations.doGetOrderTypeList,
  doSetOrderId: attachorderOperations.doSetOrderId,
  doDeleteProprietyOrder: attachorderOperations.doDeleteProprietyOrder,
  doClearOrderInfo: attachorderOperations.doClearOrderInfo,
  doSetStbType: commonOperations.doSetStbType,
  doClearOrderList: attachorderOperations.doClearOrderList,
  doRetrieveOrder: attachorderOperations.doRetrieveOrder,
  doClearOrder: attachorderOperations.doClearOrder,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
  doSetOrderModifiedCondition:
    attachorderOperations.doSetOrderModifiedCondition,
  doSetInitValues: commonOperations.doSetInitValues,
};

const FORM_NAME = 'ProprietyJudgingList';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);

